export default "__VITE_ASSET__DKADI$6W__"